import { createDisplayName } from "@domains/utils/displayName";
export var MultiQuoteMapper = function (data) {
    var mulitQuoteEntity = {
        quotesDetailsEntity: [],
    };
    mulitQuoteEntity.quotesDetailsEntity = listMapper(data.syLst);
    return mulitQuoteEntity;
};
var listMapper = function (data) {
    var finalList = [];
    if (data && data.length > 0) {
        data.map(function (syRecord) {
            var listObj = {
                displayName: createDisplayName(syRecord),
                symbol: syRecord.sym,
                tradeSymbol: syRecord.trdSym,
                dpName: syRecord.dpNm,
                lastTradedPrice: syRecord.ltp ? Number(syRecord.ltp).toString() : "",
                change: syRecord.chg ? Number(syRecord.chg).toString() : "",
                changePercentage: syRecord.chgP ? Number(syRecord.chgP).toString() : "",
                description: syRecord.desc,
                updatedTime: syRecord.lut,
                lotSize: syRecord.ltSz,
                exchange: syRecord.exc,
                maxLotSize: syRecord.mxLtSz,
                prcUnits: syRecord.prcUnits,
                qtyUnits: syRecord.qtyUnits,
                type: syRecord.asTyp,
                isin: syRecord.isin,
                asExchange: syRecord.asExc,
                asSymbol: syRecord.asSym,
                yearHigh: syRecord.yrH,
                yearLow: syRecord.yrLw,
                tickSize: syRecord.tkSz,
                lowerCircuit: syRecord.loCt,
                higherCircuit: syRecord.hiCt,
                asTyp: syRecord.asTyp,
                isNCD: syRecord === null || syRecord === void 0 ? void 0 : syRecord.isNCD,
                isETF: syRecord === null || syRecord === void 0 ? void 0 : syRecord.isETF,
                rmsAllowedQty: syRecord === null || syRecord === void 0 ? void 0 : syRecord.rmsAllowedQty,
                dpInsTyp: syRecord === null || syRecord === void 0 ? void 0 : syRecord.dpInsTyp,
                dpExpDt: syRecord === null || syRecord === void 0 ? void 0 : syRecord.dpExpDt,
            };
            finalList.push(listObj);
        });
    }
    return finalList;
};
